(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sunice-help-hub"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('input', (event) => {
    const input = event.target;
    if (!input.matches('[data-help-search]')) return;
    const hub = input.closest('[data-help-hub]');
    if (!hub) return;
    const query = input.value.trim().toLocaleLowerCase();
    let matches = 0;
    hub.querySelectorAll('[data-help-topic]').forEach((topic) => {
      const text = `${topic.textContent} ${topic.dataset.keywords || ''}`.toLocaleLowerCase();
      const visible = query === '' || text.includes(query);
      topic.hidden = !visible;
      if (visible) matches += 1;
    });
    const empty = hub.querySelector('[data-help-empty]');
    const status = hub.querySelector('[data-help-status]');
    if (empty) empty.hidden = matches !== 0;
    if (status) status.textContent = matches === 0 ? empty.textContent.trim() : '';
  });

  } catch(e) { console.error(e); }
})();
})();
